<template>
  <div class="container">
    <div class="columns">
      <div class="column card is-offset-3 is-6">
        <div class="section">
          <div class="content">
            <h3
              class="has-text-centered"
              v-text="$wording.register.error_1"
            />
            <p v-text="$wording.register.error_2" />
          </div>
          <p v-html="$wording.register.error_3" /><p class="has-text-centered">
            <router-link :to="{ name: 'login' }">
              Log in to your account
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>